import { FlagIcon } from "app/components/Icons";
import CommonPrioritySelection from "app/containers/Features/components/CommonPrioritySelection";
import { priorityOptions } from "app/containers/Features/containers/Boards/data";
import { ITicketStatus } from "app/types";
import React, { useState } from "react";
import { PriorityFilterEnum } from "../../../types";
import StatusSelectionButton from "./StatusSelectionButton";

interface PriorityDropdownProps {
  value?: PriorityFilterEnum | string;
  setValue?: (value: PriorityFilterEnum) => void;
}

const PriorityDropdown: React.FC<PriorityDropdownProps> = ({
  setValue,
  value,
}) => {
  const selectedOptions = priorityOptions.find((p) => p.value === value);

  return (
    <>
      <CommonPrioritySelection
        trigger={
          <button className="flex items-center justify-between w-full px-2 py-2 rounded-md hover:bg-[#F4F5F7] rounded-[4px] data-[state=open]:border-[#79808A] data-[state=open]:outline-[#79808A] data-[state=open]:border-[1px] border-[#79808A]">
            <StatusSelectionButton
              label="Priority:"
              selectedIcon={selectedOptions && selectedOptions.icon}
              selectedLabel={selectedOptions && selectedOptions.label}
              icon={<FlagIcon size={20} color="#79808A" />}
              className="text-[12px] leading-[18px] font-medium text-secondary mt-[2px]"
            />
          </button>
        }
        align="end"
        value={value as PriorityFilterEnum}
        setValue={setValue}
        dropDownClassName="min-w-[250px]"
      />
    </>
  );
};

export default PriorityDropdown;
